/* eslint-disable import-helpers/order-imports */
import './polyfills'
import './@types/global.d.ts'

import { StrictMode } from 'react'

import { createRoot } from 'react-dom/client'

import App from './App'
import * as serviceWorker from './serviceWorker'

import './globalStyles.css'
import sentryService from './services/sentry'

sentryService.init()

const container = document.getElementById('root')

if (container) {
  const root = createRoot(container)
  root.render(
    <StrictMode>
      <App />
    </StrictMode>
  )
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
